module.exports = __webpack_public_path__ + "static/media/wyndham-lookout.70fac9aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/wyndham-lookout.jpg
// module id = 155
// module chunks = 0